import { InvoiceSummary } from '../../../store/data/types'
import { checkDelayedPayment, statusTranslator } from '../../../common/utils'
import { whatsappBillingCXLinkGenerator } from '../../../common/constants'
import {
  StyledInvoiceSummaryCard,
  StyledLink,
  StyledWrapper,
} from './styles/InvoiceSummaryCard.style'
import { useAppSelector } from '../../../common/hooks'
import { InvoiceCardTextContent } from './InvoiceCardTextContent'
import { InvoiceCardLinkBoard } from './InvoiceCardLinkBoard'
import { InvoiceCardHeader } from './InvoiceCardHeader'
import { RatingModule } from './RatingModule'

export const InvoiceSummaryCard = ({ invoice }: { invoice: InvoiceSummary }) => {
  const merchantCode = useAppSelector((state) => state.session.merchantCode)
  const {
    shopperPlanId,
    status,
    paymentType,
    totalDeliveredPrice,
    totalPrice,
    rating,
    billings,
    quantityOfPaymentInstallments,
  } = invoice

  const isPaymentDelayed = billings
    ? billings.find((billing) => checkDelayedPayment(billing.billingStatus))
    : false

  return (
    <StyledInvoiceSummaryCard>
      <StyledWrapper>
        <InvoiceCardHeader
          title={`Entrega #${shopperPlanId}`}
          deliveryStatus={statusTranslator(status)}
          isPaymentDelayed={!!isPaymentDelayed}
        />
        {rating && <RatingModule rating={rating} />}
      </StyledWrapper>
      <InvoiceCardTextContent
        paymentType={paymentType}
        billings={billings}
        quantityOfPaymentInstallments={quantityOfPaymentInstallments}
        totalDeliveredPrice={totalDeliveredPrice}
        totalPrice={totalPrice}
      />
      <InvoiceCardLinkBoard invoice={invoice} merchantCode={merchantCode} />
      {!!isPaymentDelayed && (
        <StyledLink
          href={whatsappBillingCXLinkGenerator(merchantCode, shopperPlanId)}
          target="_blank"
          rel="noreferrer"
        >
          Já efetuou o pagamento? Nos envie o comprovante por aqui
        </StyledLink>
      )}
    </StyledInvoiceSummaryCard>
  )
}
